import { useContext } from 'react';

import { AuthFormContext } from '@webapp/account/src/components/auth/context';
import { AuthButton } from '@webapp/account/src/components/auth/misc';

export const AuthFormSubmit: FC<{
    disabled?: boolean;
    type?: 'submit' | 'button' | 'reset';
    className?: string;
    notice?: string;
    onClick?: (e: ReactMouseEvent) => void;
    children?: ReactNode;
}> = ({ children, className, disabled, notice, onClick, type = 'submit' }) => {
    const store = useContext(AuthFormContext);
    disabled = disabled || (type === 'submit' && store.hasError && store.hasTouched);

    return (
        <AuthButton className={className} disabled={disabled} notice={notice} type={type} onClick={onClick}>
            {children}
        </AuthButton>
    );
};
